import React from 'react';
import './PrivacyPolicy.css'; // Create or update corresponding CSS if needed

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy container">
      <header className="policy-header">
        <h1>Privacy Policy</h1>
      </header>

      <section className="policy-section legal-disclaimer">
        <h2>A LEGAL DISCLAIMER</h2>
        <p>
          At Advantis Solutions LLC ("we", "us", or "our"), protecting your personal information is of paramount importance. This Privacy Policy ("Policy") explains how we collect, use, disclose, and safeguard your personal data when you access or use our website and services. This Policy is designed to comply with applicable data protection laws, including the General Data Protection Regulation (GDPR) where relevant. By accessing our website and services, you agree to the practices described in this Policy.
        </p>
        <p>
          Important: This Policy is provided as a comprehensive overview of our data handling practices. While it is intended to be legally robust and effective immediately, you are encouraged to consult with legal counsel to ensure ongoing compliance with all relevant regulations.
        </p>
      </section>

      <section className="policy-section basics">
        <h2>PRIVACY POLICY - THE BASICS</h2>
        <p>
          A Privacy Policy is a legal statement that informs you about the types of personal data we collect, how we use and manage that data, and the circumstances under which we may share or disclose your information. It is intended to safeguard your privacy and provide transparency about our practices.
        </p>
      </section>

      <section className="policy-section information-collect">
        <h2>Information We Collect</h2>
        <h3>Personal Identification Information</h3>
        <p>Your name, email address, phone number, and physical mailing address.</p>

        <h3>Payment Information</h3>
        <p>Billing details and credit/debit card information provided during subscription or payment transactions. Sensitive payment data is processed securely by approved payment gateways and is not stored on our systems.</p>

        <h3>Technical and Usage Data</h3>
        <p>
          Information automatically collected when you access our services, such as your IP address, browser type, device information, access times, and pages viewed. This data helps us understand how our services are used and allows us to improve functionality and user experience.
        </p>
      </section>

      <section className="policy-section collection-methods">
        <h2>How We Collect Information</h2>
        <h3>Direct Interactions</h3>
        <p>
          Information you provide when registering for an account, filling out forms, subscribing to services, or contacting us directly.
        </p>
        <h3>Automated Technologies</h3>
        <p>
          Data collected automatically via cookies, web beacons, and similar tracking technologies. These tools help us analyze trends, administer the site, and gather demographic information for aggregate use.
        </p>
        <h3>Transactional Processes</h3>
        <p>
          Information collected during payment or subscription transactions, which is essential for processing and fulfilling your orders.
        </p>
      </section>

      <section className="policy-section processing">
        <h2>Purpose and Legal Basis for Processing</h2>
        <p>
          We process your personal data for the following purposes:
        </p>
        <ul>
          <li><strong>Service Provision:</strong> To create, manage, and deliver our SaaS offerings and related services, including customer support and technical maintenance.</li>
          <li><strong>Enhancing User Experience:</strong> To analyze usage data, improve our website functionality, and personalize your experience.</li>
          <li><strong>Communication:</strong> To send you important notifications, updates, and, where permitted by law, marketing communications.</li>
          <li><strong>Compliance and Legal Obligations:</strong> To fulfill our legal obligations and protect our rights.</li>
        </ul>
      </section>

      <section className="policy-section data-handling">
        <h2>Data Storage, Security, and Sharing</h2>
        <h3>Data Storage</h3>
        <p>
          Your personal data is stored on secure servers maintained by our trusted service providers. We implement industry-standard security measures to protect your data against unauthorized access, alteration, disclosure, or destruction.
        </p>
        <h3>Data Retention</h3>
        <p>
          We retain your personal data only for as long as is necessary to fulfill the purposes for which it was collected, or as required by applicable law. Our data retention policies are reviewed regularly to ensure compliance with legal requirements.
        </p>
        <h3>Data Sharing and Disclosure</h3>
        <p>
          We do not sell or rent your personal data to third parties. We may share your data only under the following circumstances:
        </p>
        <ul>
          <li>With trusted third-party service providers who assist us in our business operations, under strict confidentiality and data protection agreements.</li>
          <li>When required to comply with legal obligations or respond to lawful requests from public authorities.</li>
          <li>In connection with any merger, acquisition, or sale of assets, provided that the recipient agrees to adhere to confidentiality and data protection standards.</li>
        </ul>
        <h3>International Data Transfers</h3>
        <p>
          If your personal data is transferred to jurisdictions outside your country of residence, we ensure that appropriate safeguards are in place to protect your data in accordance with applicable data protection laws.
        </p>
      </section>

      <section className="policy-section cookies">
        <h2>Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and similar tracking technologies to enhance your experience on our website. These technologies may collect information such as usage data (how you navigate and interact with our website) and preference data to personalize your experience. You can manage your cookie preferences through your browser settings; however, disabling cookies may impact the functionality of our website.
        </p>
      </section>

      <section className="policy-section rights">
        <h2>Your Rights and How to Exercise Them</h2>
        <p>
          Depending on your jurisdiction, you have certain rights regarding your personal data. These rights may include:
        </p>
        <ul>
          <li><strong>Access:</strong> Requesting a copy of the personal data we hold about you.</li>
          <li><strong>Correction:</strong> Requesting correction of any inaccurate or incomplete information.</li>
          <li><strong>Deletion:</strong> Requesting the deletion of your personal data, subject to certain legal obligations.</li>
          <li><strong>Objection:</strong> Objecting to our processing of your personal data in particular circumstances.</li>
          <li><strong>Data Portability:</strong> Requesting that your personal data be transferred to another entity.</li>
        </ul>
        <p>
          To exercise these rights, please contact us at: <strong>info@advantissolutions.com</strong>
        </p>
      </section>

      <section className="policy-section consent">
        <h2>Withdrawing Consent</h2>
        <p>
          If you have provided consent for the processing of your personal data, you have the right to withdraw that consent at any time. To withdraw your consent, please contact us using the information provided above. Please note that withdrawing consent will not affect the lawfulness of any processing conducted prior to your withdrawal.
        </p>
      </section>

      <section className="policy-section updates">
        <h2>Policy Updates</h2>
        <p>
          We reserve the right to update or modify this Privacy Policy at any time. Any changes will be effective immediately upon posting the revised Policy on our website. We encourage you to review this Policy periodically to stay informed about how we are protecting your personal data. In cases of material changes, we will provide a prominent notice on our website.
        </p>
      </section>

      <section className="policy-section third-party">
        <h2>Third-Party Terms and Conditions</h2>
        <p>
          Our services may integrate or rely on third-party providers. By signing up for and using our services, you acknowledge and agree that you are also bound by any applicable third-party terms and conditions or privacy policies, including those of our partners, to the extent that such provisions affect the processing of your data. If you do not agree with those terms, please do not use our services.
        </p>
      </section>

      <section className="policy-section disclaimer">
        <h2>Disclaimer and Limitation of Liability</h2>
        <h3>Disclaimer:</h3>
        <p>
          The information contained in this Privacy Policy is provided on an "as is" basis without any representations or warranties, express or implied. Advantis Solutions LLC makes no guarantees regarding the accuracy, completeness, or suitability of the information provided herein.
        </p>
        <h3>Limitation of Liability:</h3>
        <p>
          In no event shall Advantis Solutions LLC, its affiliates, or its respective directors, officers, employees, or agents be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our website or services, even if advised of the possibility of such damages. This limitation applies to all claims, including those based on warranty, contract, tort, or any other legal theory. Some jurisdictions do not allow the exclusion or limitation of liability for certain types of damages; in such cases, our liability shall be limited to the fullest extent permitted by applicable law.
        </p>
      </section>

      <footer className="policy-footer">
        <p>© {new Date().getFullYear()} Advantis Solutions LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;